<usb-base-item [item]="item" [styleSidebar]="styleSidebar" [currencyAgency]="currencyAgency" [currencies]="currencies" [clientsSettingAppBooking]="clientsSettingAppBooking" (openMap)="openMap.emit($event)">
  <ng-container *ngFor="let room of item.rooms; let i = index; trackBy: trackByIndex">

    <!-- Hotel: habitación, ocupación y fechas -->
    <hr class="park-sep" />
    <div class="park-block">
      <!-- Estado y eliminar por habitación (solo si hay más de una) -->
      <div *ngIf="item.rooms.length > 1" class="park-room-actions">
        <span [class]="'status status-sidebar ' + getStatusHotelClass(room.status_id)">{{ room.status }}</span>
        <button *ngIf="room.status_id === 1 || room.status_id === 2" type="button" class="park-room-remove" (click)="onRemoveItem(room)"
                [title]="room.status_id === 2 ? 'cancel' : 'delete'">
          <svg viewBox="0 0 512 512" style="fill: #ff3f63; width: 18px;" xml:space="preserve">
            <path d="M422.1,82H388V53c0-29.3-23.7-53-53-53H177c-29.3,0-53,23.7-53,53v29H90c-18.8,0-34.1,15.3-34.1,34.1v54.6c0,9.4,7.6,17.1,17.1,17.1l0,0h10.3v273c0,28.3,22.9,51.2,51.2,51.2h243.2c28.3,0,51.2-22.9,51.2-51.2V187.7h10.4c9.4,0,17.1-7.6,17.1-17c0,0,0,0,0,0v-54.5C456.2,97.3,440.9,82,422.1,82z M158.1,53c0-10.4,8.5-18.9,18.9-18.9h158c10.4,0,18.9,8.4,18.9,18.9v29H158.1V53z M89.9,116.1h332.2v37.5H89.9V116.1z M394.7,460.8c0,9.4-7.6,17.1-17.1,17.1H134.4c-9.4,0-17.1-7.6-17.1-17.1V187.7h277.3V460.8z"/>
          </svg>
        </button>
      </div>

      <p class="park-name">{{ room.roomType }}</p>
      <p *ngIf="room.boardName" class="park-name">{{ room.boardName }}</p>

      <div class="park-row park-pax-row">
        <span class="park-pax"><img width="20" height="20" src="/assets/icons/search-result/hotel/HABITACION.svg" alt="" />1 Habitación</span>
        <span class="park-pax"><img width="20" height="20" src="/assets/icons/itinerary/persona.svg" alt="" />{{ room.adults }} {{ room.adults === 1 ? 'Adulto' : 'Adultos' }}</span>
        <span class="park-pax"><img width="20" height="20" src="/assets/icons/search-result/hotel/NIÑO.svg" alt="" />{{ room.childrens }} {{ room.childrens === 1 ? 'Niño' : 'Niños' }}</span>
      </div>

      <div class="park-row park-dates">
        <div class="park-date">
          <span class="park-label">Check In:</span>
          <strong *ngIf="room.arrivalDate">{{ room.arrivalDate | date: 'EEE. dd MMM yyyy' }}</strong>
          <span class="park-time">{{ hs(room?.checkTimes?.checkIn) }}</span>
        </div>
        <div class="park-date">
          <span class="park-label">Check Out:</span>
          <strong *ngIf="room.departureDate">{{ room.departureDate | date: 'EEE. dd MMM yyyy' }}</strong>
          <span class="park-time">{{ hs(room?.checkTimes?.checkOut) }}</span>
        </div>
      </div>

      <p class="park-name park-nights">{{ getNights(room) }} {{ getNights(room) === 1 ? 'noche' : 'noches' }}</p>

      <!-- Con varias habitaciones se muestra la tarifa de cada una -->
      <div *ngIf="item.rooms.length > 1 && (room?.statusId || room?.status_id) !== 5" class="park-room-price">
        <span class="park-label">Tarifa Habitación:</span>
        <strong>{{ currencyAgency?.code }} {{ getRoomDisplayPrice(room) | number: '1.2-2' }}</strong>
      </div>
    </div>

    <!-- Tickets de parque -->
    <ng-container *ngIf="ticketOf(room) as ticket">
      <hr class="park-sep" />
      <div class="park-block">
        <p class="park-name">Tickets</p>
        <p class="park-name">{{ ticketTitle(room) }}</p>

        <div class="park-row park-pax-row">
          <span class="park-pax"><img width="20" height="20" src="/assets/icons/itinerary/persona.svg" alt="" />{{ room.adults }} {{ room.adults === 1 ? 'Adulto' : 'Adultos' }}</span>
          <span class="park-pax"><img width="20" height="20" src="/assets/icons/search-result/hotel/NIÑO.svg" alt="" />{{ room.childrens }} {{ room.childrens === 1 ? 'Niño' : 'Niños' }}</span>
        </div>

        <div class="park-row park-dates">
          <div class="park-date" *ngIf="ticket.date">
            <span class="park-label">Check In:</span>
            <strong>{{ ticket.date | date: 'EEE. dd MMM yyyy' }}</strong>
          </div>
          <div class="park-date" *ngIf="ticket.days">
            <span class="park-label">Cantidad de días:</span>
            <strong>{{ ticket.days }} {{ +ticket.days === 1 ? 'día' : 'días' }}</strong>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Plan de comidas -->
    <ng-container *ngIf="mealOf(room) as meal">
      <hr class="park-sep" />
      <div class="park-block">
        <p class="park-name">Plan de Comidas</p>
        <p class="park-name">{{ meal }}</p>

        <div class="park-row park-pax-row">
          <span class="park-pax"><img width="20" height="20" src="/assets/icons/itinerary/persona.svg" alt="" />{{ room.adults }} {{ room.adults === 1 ? 'Adulto' : 'Adultos' }}</span>
          <span class="park-pax"><img width="20" height="20" src="/assets/icons/search-result/hotel/NIÑO.svg" alt="" />{{ room.childrens }} {{ room.childrens === 1 ? 'Niño' : 'Niños' }}</span>
        </div>
      </div>
    </ng-container>

  </ng-container>
</usb-base-item>
